<template lang="html">
  <div :class="wrapperClass">
    <a
      :class="{ 'pointer-events-none': isSlider }"
      :href="data.link?.url"
      :target="data.link?.target"
    >
      <div class="relative overflow-hidden">
        <div v-html="data.image"></div>
        <div
          v-if="data.custom_badge"
          class="bg-gold-600 absolute py-1 inline-block text-xs font-bold text-white -translate-x-[50%] -top-[39%] origin-right px-6 -rotate-45 text-center w-full"
        >
          {{ data.custom_badge }}
        </div>
      </div>
      <div v-if="data.sold" class="mt-5">
        <div
          class="bg-gold-600 rounded-xl px-3 text-white inline-block font-bold"
        >
          Solgt
        </div>
      </div>
      <h3
        class="mt-5 font-bold text-black dark:text-gold-50 text-xl"
        v-html="data.model"
      ></h3>

      <ul class="font-bold text-lg mt-2.5">
        <li>
          Totalpris: <span>{{ $filters.formatNumber(price) }},-</span>
        </li>
        <li>
          Månedspris:
          <span>{{ $filters.formatNumber(mndprice) }} ,-</span>
        </li>
      </ul>

      <ul class="font-light mt-5">
        <li class="mt-5">
          Nominell rente: {{ $filters.formatNumber(nominalInterest) }}%
        </li>
        <li>Effektiv rente: {{ $filters.formatNumber(effectiveInterest) }}%</li>
        <li>Egenkapital: {{ $filters.formatNumber(capital) }} NOK</li>
        <li>
          Totalpris ved finansiering:
          {{ $filters.formatNumber(totalPrice) }} NOK
        </li>
      </ul>
    </a>

    <a
      class="btn btn--transparent-black w-full mt-6"
      :href="data.link?.url"
      :target="data.link?.target"
    >
      {{ data.link?.title }}
    </a>
  </div>
</template>

<script>
import rates from '../data/rates';
import Helper from '../helper/FinancialHelper';

export default {
  name: 'CampaignCar',
  props: ['car', 'class'],
  data() {
    return {
      data: [],
      price: 0,
      totalPrice: 0,
      years: 0,
      capital: 0,
      mndprice: 0,
      nominalInterest: 0,
      effectiveInterest: 0,
      wrapperClass: (this.class || '') + ' flex flex-col justify-between',
      isSlider: this.class?.includes('keen-slider__slide'),
    };
  },
  mounted() {
    this.data = JSON.parse(this.car);
    if (this.data.financing && this.data.financing[0] === 'leasing') {
      this.calculateLeasing();
    } else {
      this.calculateBuy();
    }
  },
  methods: {
    calculateBuy() {
      const carRate = rates.standard;
      this.price = +this.data.financial_information.price;
      this.years = 10; // I bet its 3 years

      this.nominalInterest =
        this.data.financial_information.interest_rate ||
        carRate.nominalInterest;
      // I guess it is nominal interest

      this.capital = Helper.getCapital(this.price, carRate.capital); // I took capital from carRate

      const realPrice = Helper.calculateRealPrice(
        this.price,
        carRate.registrationCost,
        carRate.preparationFee,
        this.capital
      );

      this.mndprice = Helper.calculateMonthlyPrice(
        realPrice,
        this.nominalInterest,
        this.years,
        carRate.monthlyCost
      );

      this.effectiveInterest = Helper.calculateEffectiveRate(
        realPrice,
        +this.nominalInterest,
        this.years,
        carRate.monthlyCost,
        carRate.registrationCost,
        carRate.preparationFee
      );

      this.totalPrice = this.mndprice * (this.years * 12) + this.capital;
    },
    calculateLeasing() {
      this.years = 10; // I bet its 3 years
      const carRate = rates.standard;
      const financial = this.data.financial_information;
      const starting_price = parseInt(financial.leasing.starting_price);
      const kilometer = financial.leasing.kilometer_fees[0];
      const { fee, amount } = financial.leasing.upfront_costs[0];
      const upfront = {
        cost: +amount,
        fee: +fee,
      };

      this.mndprice = Helper.calculateLeasingMonthlyFee(
        starting_price,
        +kilometer.fee,
        upfront.fee
      );

      this.totalPrice = Helper.calculateLeasingTotalPrice(
        starting_price,
        +kilometer.fee,
        upfront
      );
      this.price = this.totalPrice;

      this.capital = upfront.cost;

      this.nominalInterest =
        this.data.financial_information.interest_rate ||
        carRate.nominalInterest;

      this.effectiveInterest = Helper.calculateEffectiveRate(
        this.totalPrice,
        +this.nominalInterest,
        this.years,
        carRate.monthlyCost,
        carRate.registrationCost,
        carRate.preparationFee
      );
    },
  },
};
</script>
